const RequestDataStore = {
	state: () => ({ fieldData: [], objectSchema: {}, objectModel: {} }),
	mutations: {
		SET_OBJ_SCHEMA(state, payload) {
			state.objectSchema = payload;
		},
		SET_OBJ_MODEL(state, payload) {
			state.objectModel = payload;
		},
		SET_FIELD_DATA(state, payload) {
			state.fieldData = payload;
		},
	},
	actions: {
		setFieldData({ commit }, items) {
			commit("SET_FIELD_DATA", items);
		},
		setObjectModel({ commit }, data) {
			commit("SET_OBJ_MODEL", data);
		},
		setObjectSchema({ commit }, data) {
			commit("SET_OBJ_SCHEMA", data);
		},
	},
	getters: {
		fieldCount: (state) => state.fieldData.length,
	},
	namespaced: true,
};
export default RequestDataStore;
